var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"export_result_btn"}},[_c('v-btn',{on:{"click":function($event){return _vm.onClickExport('csv')}}},[_vm._v("CSV")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }